import { TextField } from '@atoms';
import { FC } from 'react';
import { LABEL_OPTIONS_NEWS_WIRE, NewsWireLabels } from '../constants';
import { SelectFabric } from '@molecules';

export type NEWS_WIRE_LABEL_OPTION = {
  value: NewsWireLabels;
  label: NewsWireLabels;
};

const AddNewsWireModalForm: FC<{ control: any }> = ({ control }) => (
  <>
    <TextField
      name="title"
      label="News Title"
      placeholder="Enter your title"
      control={control}
      sx={{ mb: '20px' }}
    />
    <TextField
      name="url"
      label="Url"
      placeholder="Enter Url"
      control={control}
      sx={{ mb: '20px' }}
    />
    <TextField
      name="imageUrl"
      label="Image Url"
      placeholder="Enter the image url"
      control={control}
      sx={{ mb: '20px' }}
    />
    <SelectFabric
      name="label"
      label="News Label"
      placeholder="Select a label"
      control={control}
      options={LABEL_OPTIONS_NEWS_WIRE}
      sx={{ mb: '20px' }}
    />
  </>
);

export default AddNewsWireModalForm;
